import { RiCheckboxCircleLine, RiLoader2Line } from '@remixicon/react'
import { FC, useMemo } from 'react'
import { Button } from '../..'
import classes from './style.module.css'

interface IFormSubmitButtonWithLoaderProps {
  label: string
  isLoading?: boolean
  loaderLabel?: string
  isSuccess?: boolean
  successLabel?: string
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset' | undefined
  onClick?: (() => void) | undefined
}

export const FormSubmitButtonWithLoader: FC<
  IFormSubmitButtonWithLoaderProps
> = ({
  label,
  isLoading = false,
  loaderLabel = 'Loading...',
  isSuccess = false,
  successLabel,
  disabled,
  type = 'submit',
  onClick,
}) => {
  const buttonBg = useMemo(
    () =>
      isSuccess
        ? 'var(--mantine-color-Success-5)'
        : 'var(--mantine-color-Primary-6)',
    [isSuccess],
  )

  const leftSectionIcon = useMemo(() => {
    if (isLoading)
      return <RiLoader2Line size={20} className={classes.loaderIcon} />
    if (isSuccess) return <RiCheckboxCircleLine size={20} />
    return null
  }, [isLoading, isSuccess])

  const getButtonText = () => {
    if (isLoading) return loaderLabel
    if (isSuccess) return successLabel || label
    return label
  }

  return (
    <Button
      flex={{ base: 'none', md: 1 }}
      buttonType={type}
      radius='md'
      c='var(--mantine-color-Primary-1)'
      bg={buttonBg}
      fz='xs'
      fw={500}
      disabled={isLoading || isSuccess || disabled}
      leftSection={leftSectionIcon}
      onClick={onClick}
    >
      {getButtonText()}
    </Button>
  )
}
